export default __webpack_public_path__ + "static/media/Tillie.54e3b8ed.png";